import { connect } from 'react-redux'
import { number } from 'prop-types'
import React from 'react'

const NumberOfResults = props => (
  <div className="number-of-results">
    {props.numberOfResults === 1 &&
      <div>{props.numberOfResults} result</div>
    }
    {props.numberOfResults !== 1 &&
      <div>{props.numberOfResults} results</div>
    }
  </div>
)
NumberOfResults.propTypes = {
  numberOfResults: number.isRequired,
}

const mapStateToProps = state => ({
  numberOfResults: state.venue.venues.length,
})

export default connect(mapStateToProps, {
})(NumberOfResults)
